// import { langDefault, langList } from '@i18n/i18nOption.json'
import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
import i18nOption from "@i18n/i18nOption.json";
export default {
  name: "myLang",
  inject: ["reload"],
  computed: {
    ...walletVuex.mapState(["isMobile"]),
    langList() {
      return i18nOption.langList;
    },
    defaultLang() {
      return i18nOption.langDefault;
    }
  },
  data() {
    return {
      selectLang: "",
      flag: "",
      popLangShow: false,
      selectLangValue: ""
    };
  },
  watch: {
    selectLangValue: {
      handler(val) {
        console.log("vallllllllllll", val);
        if (val == "") {
          this.initLang();
          return;
        }
        // const rtlLangs = ["ar", "he", "fa", "ur"];
        // if(rtlLangs.includes(langObj.value)) {
        //   this.setRTLang(langObj);
        // } else {
        //   document.documentElement.dir = "ltr";
        // }
      },

      immediate: true
    }
  },
  created() {
    this.initLang();
  },
  methods: {
    onLangShow() {
      this.popLangShow = true;
    },
    normalizeLang(code) {
      const map = {
        "pt-pt": "pt",
        "pt-br": "pt",
        tl: "fil",
        ko: "kr",
        vi: "vn",
        ja: "jp",
        "zh-TW": "cht",
        "zh-hk": "cht"
      };
      return map[code] || code;
    },
    showFn() {
      this.popLangShow = true;
    },
    findLang(value = "") {
      value = this.normalizeLang(value);
      return this.langList.find(item => value === item.value || value.startsWith(item.value + "-")) || this.langList[0];
    },
    initLang() {
      if (!localStorage.getItem("aLang")) {
        let langCode = "en";
        const tgLang = window?.Telegram?.WebApp?.initDataUnsafe?.user?.language_code;
        const browserLang = navigator?.language?.toLowerCase();
        if (tgLang) {
          langCode = this.normalizeLang(tgLang.toLowerCase());
        } else if (browserLang) {
          langCode = this.normalizeLang(browserLang);
        }
        localStorage.setItem("lang", langCode);
      }
      const stored = localStorage.getItem("lang") || this.defaultLang;
      const langObj = this.findLang(stored);
      this.applyLang(langObj);
    },
    setRTLang(langObj) {
      const rtlLangs = ["ar", "he", "fa", "ur"];
      document.documentElement.dir = rtlLangs.includes(langObj.value) ? "rtl" : "ltr";
    },
    applyLang(langObj) {
      this.setRTLang(langObj);
      this.selectLang = langObj.label;
      this.selectLangValue = langObj.text;
      this.flag = langObj.flag;
      this.$i18n.locale = langObj.value;
      localStorage.setItem("lang", langObj.value);
    },
    onSelect(item) {
      if (item.label === this.selectLang) return;
      this.applyLang(item);
      localStorage.setItem("aLang", true);
      this.$nextTick(() => this.reload());
    },
    hidePop() {
      this.popLangShow = false;
    }
  },
  destroyed() {
    window.removeEventListener("click", this.hidePop);
  },
  mounted() {
    document.body.addEventListener("click", this.hidePop);
  }
};